import Time from "client/classes/Time";
import Separator from "client/components/layout/Separator";
import Spacer from "client/components/layout/Spacer";
import useEventListener from "client/components/reactUtils/useEventListener";
import VersionDisplay from "client/components/statusBar/VersionDisplay";
import { CustomEventTypes, LayoutOrientations } from "client/globals";
import { useState } from "react";

const Statusbar = () =>
{
	useEventListener(CustomEventTypes.FPSUpdated, () => setFPS(Time.getFPS()), document);

	const [FPS, setFPS] = useState(0);

	return (
		<div className="statusBar">
			<Spacer stretchTo={{ x: "100%" }} />
			<div data-name={"performance-monitor-fps"}>
				{"FPS: " + FPS}
			</div>
			<Separator className={"inverse"} orientation={LayoutOrientations.Vertical} />
			<VersionDisplay />
		</div>
	);
};

export default Statusbar;